import type { FC } from "react";

import { AppStrings } from "../../../utils/constants/AppStrings";
import type { StaffRegulatorStatus } from "../../../queries/staff-regulators/types";

import styles from "./StaffRegulatorStatusBadge.module.css";

export type StaffRegulatorStatusBadgeProps = {
  status: StaffRegulatorStatus;
};

const StaffRegulatorStatusBadge: FC<StaffRegulatorStatusBadgeProps> = ({
  status,
}) => (
  <span
    className={`${styles.statusBadge} ${
      status === "approved" ? styles.statusApproved : styles.statusPending
    }`}
  >
    {status === "approved"
      ? AppStrings.COMPLIANCE_REGULATOR_STATUS_APPROVED
      : AppStrings.COMPLIANCE_REGULATOR_STATUS_PENDING}
  </span>
);

export default StaffRegulatorStatusBadge;
